import { HttpErrorResponse } from '@angular/common/http';
import { MonoTypeOperatorFunction, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * HTTP Error Handler Helper
 *
 * Provides consistent error handling for HTTP requests across services.
 * Logs errors and optionally returns a fallback value or re-throws.
 *
 * @param errorMessage  Human-readable context for the failed operation
 * @param fallback      Optional fallback value to emit instead of throwing
 * @returns             RxJS operator function for use in .pipe()
 *
 * Usage:
 *   this.http.get(url).pipe(handleHttpError('fetching previews', []))
 */
export function handleHttpError<T>(errorMessage: string, fallback?: T): MonoTypeOperatorFunction<T> {
  return catchError((error: HttpErrorResponse) => {
    console.error(`[HTTP Error] ${errorMessage}:`, error.message);

    if (fallback !== undefined) {
      return of(fallback as T);
    }

    return throwError(() => error);
  }) as MonoTypeOperatorFunction<T>;
}
